<div class="clear-item-dialog-container">
    <div class="clear-item-dialog-header-container">
        <div>  <p class="clear-item-dialog-header-text clear-item-section-headers">DELETE ITEM?</p></div>
        <div><p class="clear-item-dialog-sub-heading">Are you sure you want to delete selected item?</p></div>
    </div>

    <div class="clear-item-btn-dialog-container">

        <button class="cancel-clear-item-dialog-btn" mat-flat-button type="button" (click)="cancelClearingItems()">
            <div class="cancel-clear-item-btn-content">
                <span><p class="cancel-clear-item-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="clear-item-btn" mat-flat-button type="button"
                (click)="deleteItemById()">
            <div class="clear-item-btn-content">
                <span><p class="clear-item-btn-text">DELETE</p></span>
            </div>
        </button>
    </div>

</div>
